import { RouteView } from '@/layouts';

const auditRouter = {
  path: '/audit',
  name: 'Audit',
  redirect: '/audit/list',
  component: RouteView,
  meta: {
    title: '审核管理',
    icon: 'iconsuggest',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'AuditList',
      component: () => import('@/views/audit/List'),
      meta: {
        title: '审核列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'order',
      name: 'AuditOrder',
      component: () => import('@/views/audit/Order'),
      meta: {
        title: '订单生成',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default auditRouter;
